export function Logo({ alt = 'Catchment logo', className, ...props }) {
  return (
    <img
      src="/brand/logo.svg"
      alt={alt}
      className={className}
      {...props}
    />
  )
}
